import { render, staticRenderFns } from "./RelBuild.vue?vue&type=template&id=7ccf9676&scoped=true"
import script from "./RelBuild.vue?vue&type=script&lang=js"
export * from "./RelBuild.vue?vue&type=script&lang=js"
import style0 from "./RelBuild.vue?vue&type=style&index=0&id=7ccf9676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccf9676",
  null
  
)

export default component.exports